module.exports = __webpack_public_path__ + "static/media/SUPERIOR_ROYAL_BIRD.978688e2.jpeg";